/* Complete by Dr SCS: basket cross-sell.
   Every system is two halves: a serum for the skin and a supplement that works from
   within. When the basket holds one half without the other (and without the system),
   the drawer and the basket page offer the missing half, plus a one-click switch to the
   system, which costs less than buying the two separately. Product data (variant, price,
   image) comes from snippets/complete-xsell.liquid, so prices always match the store. */
(function () {
  var XSELL = {
    'clarify-serum': { line: 'Clarify', partner: 'clarify-capsules', system: 'clarify-system', pname: 'Clarify Capsules',
      why: 'The capsules work from within, with a 6-strain probiotic and zinc, which contributes to the maintenance of normal skin.' },
    'clarify-capsules': { line: 'Clarify', partner: 'clarify-serum', system: 'clarify-system', pname: 'Clarify Serum',
      why: 'The serum works on the skin, with 10% azelaic acid, salicylic acid and niacinamide.' },
    'protect-serum': { line: 'Protect', partner: 'protect-capsules', system: 'protect-system', pname: 'Protect Capsules',
      why: 'The capsules work from within, with coenzyme Q10, hyaluronic acid, ceramides and vitamin C, which contributes to normal collagen formation for the normal function of skin.' },
    'protect-capsules': { line: 'Protect', partner: 'protect-serum', system: 'protect-system', pname: 'Protect Serum',
      why: 'The serum works on the skin, with HPR, a gentle retinol alternative, plus bakuchiol and ceramides.' },
    'radiance-serum': { line: 'Radiance', partner: 'dual-collagen-complex', system: 'radiance-system', pname: 'Dual Collagen Complex',
      why: 'It works from within, with plant-based VeCollal collagen types I and II and vitamin C, which contributes to normal collagen formation for the normal function of skin and cartilage. It supports skin, hair, nails and joints.' },
    'dual-collagen-complex': { line: 'Radiance', partner: 'radiance-serum', system: 'radiance-system', pname: 'Radiance Serum',
      why: 'The serum works on the skin, with 20% vitamin C, alpha arbutin and resveratrol, for brighter, more even-looking skin.' }
  };

  function money(cents) {
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP' });
  }
  function getCart() { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }
  function settle() {
    return (window.CompleteCart && typeof window.CompleteCart.settle === 'function') ? window.CompleteCart.settle() : Promise.resolve();
  }

  function offers(cart) {
    var P = window.COMPLETE_XSELL_PRODUCTS || {};
    var inCart = {};
    (cart.items || []).forEach(function (it) { inCart[it.handle] = true; });
    var seen = {}, out = [];
    (cart.items || []).forEach(function (it) {
      var x = XSELL[it.handle];
      if (!x || seen[x.line] || inCart[x.partner] || inCart[x.system]) return;
      if (it.properties && it.properties._gift) return;
      if (it.final_price === 0) return;
      var partner = P[x.partner], sys = P[x.system], self = P[it.handle];
      if (!partner || !partner.avail) return;
      seen[x.line] = true;
      out.push({ item: it, x: x, partner: partner, sys: (sys && sys.avail) ? sys : null, self: self });
    });
    return out;
  }

  function html(cart) {
    return offers(cart).map(function (o) {
      var x = o.x, it = o.item;
      var oneTime = !it.selling_plan_allocation;
      var saving = (o.sys && o.self) ? (o.self.price + o.partner.price - o.sys.price) : 0;
      var btn = 'display:block;width:100%;text-align:center;border-radius:12px;padding:11px 12px;font-size:.84rem;cursor:pointer;margin-top:8px;font-family:inherit;';
      return '<div style="margin:18px 0 8px;padding:16px;background:#fff;border:1px solid rgba(27,24,22,.08);border-radius:16px">' +
        '<div style="font-size:.68rem;font-weight:600;letter-spacing:.16em;text-transform:uppercase;color:#B7AAA1;margin-bottom:8px">Complete your ' + x.line + ' System</div>' +
        '<div style="display:flex;gap:12px;align-items:flex-start">' +
        (o.partner.img ? '<img src="' + o.partner.img + '" alt="" style="width:60px;height:70px;object-fit:cover;border-radius:10px;background:#eee;flex:0 0 auto">' : '') +
        '<div style="min-width:0"><div style="font-family:\'Cormorant Garamond\',serif;font-size:1.1rem;line-height:1.15;color:#1B1816">' + x.pname + '</div>' +
        '<div style="font-size:.78rem;color:#37322E;line-height:1.45;margin-top:4px">' + x.why + '</div></div></div>' +
        ((o.sys && oneTime && saving > 0) ?
          '<button type="button" data-xs-swap="' + it.key + '" data-xs-sys="' + o.sys.v + '" data-xs-qty="' + it.quantity + '" style="' + btn + 'background:#1B1816;color:#fff;border:0;border-bottom:2px solid #DEBF8E">Switch to the ' + x.line + ' System, ' + money(o.sys.price) + '</button>' +
          '<div style="font-size:.72rem;color:#3e7d5a;text-align:center;margin-top:4px">Save ' + money(saving) + ' on buying the two separately</div>' : '') +
        '<button type="button" data-xs-add="' + o.partner.v + '" style="' + btn + 'background:none;color:#1B1816;border:1px solid rgba(27,24,22,.2)">Add ' + x.pname + ', ' + money(o.partner.price) + '</button>' +
        ((o.sys && !oneTime) ? '<a href="/products/' + x.system + '" style="display:block;text-align:center;font-size:.76rem;color:#37322E;text-decoration:underline;margin-top:8px">See the ' + x.line + ' System</a>' : '') +
        '</div>';
    }).join('');
  }

  function bind(el, onDone) {
    el.addEventListener('click', function (e) {
      var add = e.target.closest && e.target.closest('[data-xs-add]');
      var swap = e.target.closest && e.target.closest('[data-xs-swap]');
      if (!add && !swap) return;
      e.preventDefault();
      e.stopPropagation();
      var b = add || swap;
      b.style.opacity = '.6'; b.style.pointerEvents = 'none';
      var go = add
        ? post('/cart/add.js', { items: [{ id: parseInt(add.getAttribute('data-xs-add'), 10), quantity: 1 }] })
        : post('/cart/change.js', { id: swap.getAttribute('data-xs-swap'), quantity: 0 }).then(function () {
            return post('/cart/add.js', { items: [{ id: parseInt(swap.getAttribute('data-xs-sys'), 10), quantity: parseInt(swap.getAttribute('data-xs-qty'), 10) || 1 }] });
          });
      go.then(settle).catch(function () {}).then(onDone);
    });
  }

  /* Drawer: complete-theme.js redraws the drawer body on every change, so the offer is
     appended after each redraw. The wrapper marks it as ours, so appending it does not
     trigger another round. */
  var drawerBody = document.querySelector('[data-cart-body]');
  var pending = false;
  function fillDrawer() {
    if (!drawerBody || pending || drawerBody.querySelector('[data-xsell-wrap]')) return;
    pending = true;
    getCart().then(function (cart) {
      pending = false;
      if (drawerBody.querySelector('[data-xsell-wrap]') || !cart.item_count) return;
      var h = html(cart);
      if (!h) return;
      var w = document.createElement('div');
      w.setAttribute('data-xsell-wrap', '');
      w.innerHTML = h;
      drawerBody.appendChild(w);
    }).catch(function () { pending = false; });
  }
  if (drawerBody) {
    bind(drawerBody, function () {
      if (window.CompleteCart && window.CompleteCart.refresh) window.CompleteCart.refresh();
    });
    if (window.MutationObserver) new MutationObserver(fillDrawer).observe(drawerBody, { childList: true });
    fillDrawer();
  }

  /* Basket page: the offer sits under the basket lines; the page reloads after a change
     so its server-rendered totals stay right. */
  var pageLines = document.querySelector('#cart-form [data-cart-lines]');
  if (pageLines) {
    getCart().then(function (cart) {
      var h = html(cart);
      if (!h) return;
      var w = document.createElement('div');
      w.style.maxWidth = '520px';
      w.innerHTML = h;
      pageLines.parentNode.insertBefore(w, pageLines.nextSibling);
      bind(w, function () { window.location.reload(); });
    }).catch(function () {});
  }
})();
